import CompanyUser from "../../../model2/company-user-new/company-user";
import {EntityType} from "../../const/item";
import {ProjectAccess} from "../../const/project";
import Chat from "../../../model2/chat/chat/chat";
import Meeting from "../../../model2/meeting/meeting";
import Task from "../../../model2/task/task";
import {MentionOption} from "../../../gd-components/editor/plugins/mentions/option";

// const debug = "MentionsManager"
const debug = false

type GetMentionOptions = {
    task?       : Task
    projectId?  : ID
    companyId?  : ID
}


export default class MentionsManager {

    static getMentionsForTask(options: GetMentionOptions, task: Task):MentionOption[] {

        const users = MentionsManager.getMentions(options)

        const projectUserIds = _.map(MentionsManager.getProjectUsers(task.projectId), (user)=>user.userId)

        let groupedUsers: MentionOption[] = []

        // Task and project users
        if (options.task && !options.projectId) {

            const taskUsers: MentionOption[] = _.filter(users, (user)=> task?.userIds.includes(user.id))
            const projectUsers: MentionOption[] = _.filter(users, (user)=> !task?.userIds.includes(user.id) && projectUserIds.includes(user.id))
            const companyUsers: MentionOption[] = _.filter(users, (user)=> !task?.userIds.includes(user.id) && !projectUserIds.includes(user.id))

            groupedUsers.push( new MentionOption({
                id      : "task-users",
                name    : "Task users",
                type    : EntityType.GROUP // Patch. This is not a real entity. It's used to add a group header.
            }))

            groupedUsers = [...groupedUsers, ...taskUsers]

            if (projectUsers.length > 0) {
                groupedUsers.push( new MentionOption({
                    id      : "project-users",
                    name    : "Project users",
                    type    : EntityType.GROUP
                }))

                groupedUsers = [...groupedUsers, ...projectUsers]
            }

            if (companyUsers.length > 0) {
                groupedUsers.push( new MentionOption({
                    id      : "company-users",
                    name    : "Company users",
                    type    : EntityType.GROUP
                }))

                groupedUsers = [...groupedUsers, ...companyUsers]
            }
        }

        // Project users and company users (if any)
        if (options.projectId && !options.task) {

            const projectUsers: MentionOption[] = _.filter(users, (user)=> projectUserIds.includes(user.id))
            const companyUsers: MentionOption[] = _.filter(users, (user)=> !projectUserIds.includes(user.id))

            groupedUsers.push( new MentionOption({
                id      : "project-users",
                name    : "Project users",
                type    : EntityType.GROUP
            }))

            groupedUsers = [...groupedUsers, ...projectUsers]

            if (companyUsers.length > 0) {
                groupedUsers.push( new MentionOption({
                    id      : "company-users",
                    name    : "Company users",
                    type    : EntityType.GROUP
                }))

                groupedUsers = [...groupedUsers, ...companyUsers]
            }
        }

        return groupedUsers
    }

    static getMentionsForMeeting(options: GetMentionOptions, meeting: Meeting): MentionOption[] {

        const users = MentionsManager.getMentions(options)

        let groupedUsers: MentionOption[] = []

        const meetingUsers: MentionOption[] = _.filter(users, (user)=> !!meeting.users?.userIds.includes(user.id))
        const companyUsers: MentionOption[] = _.filter(users, (user)=> !meeting?.users?.userIds.includes(user.id))

        groupedUsers.push( new MentionOption({
            id      : "meeting-users",
            name    : "Meeting users",
            type    : EntityType.GROUP
        }))

        groupedUsers = [...groupedUsers, ...meetingUsers]

        if (companyUsers.length > 0) {
            groupedUsers.push(new MentionOption({
                id      : "company-users",
                name    : "Company users",
                type    : EntityType.GROUP
            }))

            groupedUsers = [...groupedUsers, ...companyUsers]
        }

        return groupedUsers
    }


    static getMentionsForChat(options: GetMentionOptions, chat: Chat): MentionOption[] {

        const users = MentionsManager.getMentions(options)

        let groupedUsers: MentionOption[] = []

        const chatUsers: MentionOption[] = _.filter(users, (user)=> chat?.userIds.includes(user.id))
        const companyUsers: MentionOption[] = _.filter(users, (user)=> !chat?.userIds.includes(user.id))

        groupedUsers.push(new MentionOption({
            id      : "chat-users",
            name    : "Chat users",
            type    : EntityType.GROUP
        }))

        groupedUsers = [...groupedUsers, ...chatUsers]

        if (companyUsers.length > 0) {
            groupedUsers.push( new MentionOption({
                id      : "company-users",
                name    : "Company users",
                type    : EntityType.GROUP
            }))

            groupedUsers = [...groupedUsers, ...companyUsers]
        }

        return groupedUsers
    }

    static getMentions(options: GetMentionOptions): MentionOption[] {

        debug && console.log(debug, " options: ", options)

        let mentionOptions: MentionOption[] = []

        if (options.companyId) {

            const companyUsers: CompanyUser[] = gd.session.companyUsers.filterByCompany(options.companyId).models

            _.map(companyUsers, (cu: CompanyUser)=> {

                const user = cu.user

                if (user) {
                    mentionOptions.push( new MentionOption({
                        id              : user.id,
                        name            : user.name,
                        type            : EntityType.USER,
                        data            : user
                    }))
                }
            })
        }

        if (options.projectId || options.task) {

            const projectId = options.task ? options.task.projectId : options.projectId;

            _.map(MentionsManager.getProjectUsers(projectId!), (pu)=> {

                const user = pu.user;

                if (user && pu.access >= ProjectAccess.STANDARD) {

                    mentionOptions.push( new MentionOption({
                        id              : user.id,
                        name            : user.name,
                        type            : EntityType.USER,
                        data            : user
                    }));
                }
            })

            if (options.task) {

                const taskUsers: ID[] = _.map(options.task.users, (u)=>u.userId) || [];

                taskUsers.map((userId: ID)=> {

                    const user = gd.session.users.get(userId)

                    if (user) {
                        mentionOptions.push( new MentionOption({
                            id              : user.id,
                            name            : user.name,
                            // userId: user.id,
                            // type: 'user', // Why 'user'?. In MentionOption type: EntityType
                            type            : EntityType.USER, // 'user' not used
                            data            : user
                        }))
                    }
                })
            }
        }

        mentionOptions = _.uniqBy(mentionOptions, (r: MentionOption)=>r.id);

        return mentionOptions;
    }

    static getProjectUsers(projectId: ID) {

        const users = gd.session.projectUsers.filterByProject(projectId).models || []

        return _.filter(users, (pu)=>pu.access >= ProjectAccess.STANDARD)
    }
}
